export { default } from './RoundedButton';
